var render, staticRenderFns
import script from "./PersonalIdentificationForm.vue?vue&type=script&lang=js&"
export * from "./PersonalIdentificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcd9ef8",
  null
  
)

export default component.exports